import React, { FC } from "react";
import { SVGProps } from "react";

interface ShareIconProps extends SVGProps<SVGSVGElement> {
    size: number;
}

export const PositionShareIcon: FC<ShareIconProps> = (props) => {
    const { size = 12, ...rest } = props;

    return (
        <svg
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 12 12"
            fill="white"
            fillOpacity={0.2}
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M12 2.15625C12 3.34711 11.0346 4.3125 9.84375 4.3125C9.35738 4.3125 8.90862 4.15147 8.54788 3.87982C8.35232 3.73255 8.09071 3.67718 7.87245 3.78807L4.6238 5.43865C4.41861 5.5429 4.3125 5.76985 4.3125 6C4.3125 6.24997 4.42552 6.49813 4.64838 6.61136L7.85117 8.23863C8.0677 8.34864 8.32743 8.2917 8.51895 8.14236C8.8845 7.85731 9.34429 7.6875 9.84375 7.6875C11.0346 7.6875 12 8.65289 12 9.84375C12 11.0346 11.0346 12 9.84375 12C8.65289 12 7.6875 11.0346 7.6875 9.84375C7.6875 9.60131 7.57706 9.36124 7.36091 9.25142L4.23742 7.66444C3.96332 7.52517 3.63528 7.59877 3.38254 7.77383C3.03439 8.01497 2.61182 8.15625 2.15625 8.15625C0.965386 8.15625 0 7.19086 0 6C0 4.80914 0.965386 3.84375 2.15625 3.84375C2.62109 3.84375 3.05157 3.99084 3.4037 4.24102C3.6576 4.4214 3.99009 4.49874 4.26776 4.35766L7.33674 2.79838C7.57042 2.67965 7.6875 2.41837 7.6875 2.15625C7.6875 0.965386 8.65289 0 9.84375 0C11.0346 0 12 0.965386 12 2.15625Z"
                // fill="white"
                // fill-opacity="0.2"
            />
        </svg>
    );
};
